import { Alert, AlertDescription, AlertIcon } from "@chakra-ui/alert";
import { Panel } from "@xyflow/react";
import { AppEdge } from "features/entities/EntityCreatePage/EntityGraph/edges/types";
import { INVESTOR_GROUP_PREFIX } from "features/entities/EntityCreatePage/EntityGraph/entityGraphConstants";
import { useCommittingEntities } from "features/entities/EntityCreatePage/EntityGraph/hooks/useCommittingEntities";
import { AppNode } from "features/entities/EntityCreatePage/EntityGraph/nodes/types";
import reject from "lodash-es/reject";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useNudge = (
  initalNodes: AppNode[],
  initialEdges: AppEdge[],
): React.ReactNode => {
  const committedEntites = useCommittingEntities();

  const untargetedNodes = useMemo(() => {
    const nodeWithIncomingEdges = new Set(
      initialEdges.map((edge) => edge.target),
    );

    const nodesWithoutIncomingEdgesExcludingInvestors = reject(
      initalNodes,
      (node) =>
        nodeWithIncomingEdges.has(node.id) ||
        node.id.includes(INVESTOR_GROUP_PREFIX) ||
        (node.data.entity.id && committedEntites.has(node.data.entity.id)),
    );

    return nodesWithoutIncomingEdgesExcludingInvestors;
  }, [committedEntites, initalNodes, initialEdges]);

  const { t } = useTranslation(["common", "entity"]);

  return untargetedNodes.length > 0 ? (
    <Panel position="top-right">
      <Alert width="300px" status="warning">
        <AlertIcon />
        <AlertDescription>{t("entity:create.nudge")}</AlertDescription>
      </Alert>
    </Panel>
  ) : null;
};
